import { getUser, signIn, update, changePassword, createUser } from "../../app/services/user";
import { getCenters } from "../../app/services/center";
import { getRoles } from "../../app/services/role";
import { sendMail, validLink, submit } from "../../app/services/passwordReset";

const handleError = (dispatch, err) => {
  dispatch(
    notification({
      message:
        err.status === 401
          ? "شما به این قسمت دسترسی ندارید"
          : err.message
          ? err.message
          : "خطایی رخ داده، لطفا با مدیر سیستم تماس بگیرید",
      variant: "error"
    })
  );
};

export const setUser = user => ({
  type: "SET_USER",
  user
});

export const logOut = () => ({
  type: "LOGOUT_USER"
});

export const notification = notification => ({
  type: "NOTIFICATION",
  notification
});

export const setCenters = center => ({
  type: "CENTER",
  center
});

export const setRoles = role => ({
  type: "ROLE",
  role
});

// Action Creators - Redux Thunk
export const centerFetch = () => dispatch => {
  getCenters()
    .then(centers => {
      dispatch(setCenters(centers));
    })
    .catch(err => {
      handleError(dispatch, err);
    });
};

export const roleFetch = () => dispatch => {
  getRoles()
    .then(role => {
      dispatch(setRoles(role));
    })
    .catch(err => {
      handleError(dispatch, err);
    });
};


export const userFetch = ({ setLoading }) => dispatch => {
  getUser()
    .then(user => {
      dispatch(setUser({ user }));
      setLoading(false);
    })
    .catch(() => {
      dispatch(logOut());
      setLoading(false);
    });
};


export const userSignIn = ({
  values,
  handleSignInError,
  history
}) => dispatch => {
  signIn(values)
    .then(user => {
      dispatch(setUser(user));
      dispatch(
        notification({
          message: "به سامانه خوش آمدید",
          variant: "success"
        })
      );
      history.replace("/dashboard");
    })
    .catch(err => {
      handleError(dispatch, err);
      handleSignInError(err);
    });
};

export const register = ({
  values,
  handleRegisterError,
  history
}) => dispatch => {
  createUser(values)
    .then(user => {
      dispatch(setUser(user));
      dispatch(
        notification({
          message: "به سامانه خوش آمدید",
          variant: "success"
        })
      );
      history.replace("/dashboard");
    })
    .catch(err => {
      handleError(dispatch, err);
      handleRegisterError(err);
    });
};

export const updateUserSelf = ({ values, loading }) => dispatch => {
  update({ values })
    .then(user => {
      dispatch(setUser({ user }));
      dispatch(
        notification({
          message: "پروفایل شما با موفقیت بروزرسانی شد",
          variant: "success"
        })
      );
      loading(false);
    })
    .catch(err => {
      handleError(dispatch, err);
      loading(false);
    });
};

export const changePasswordSelf = ({
  email,
  password,
  newPassword,
  loading
}) => dispatch => {
  changePassword({ email, password, newPassword })
    .then(() => {
      dispatch(
        notification({
          message: "رمز عبور شما با موفقیت بروزرسانی شد",
          variant: "success"
        })
      );
      loading(false);
    })
    .catch(err => {
      handleError(dispatch, err);
      loading(false);
    });
};

export const userForgetPassword = ({ values, loading }) => dispatch => {
  sendMail(values)
    .then(() => {
      dispatch(
        notification({
          message: "لینک تغییر رمز عبور به ایمیل شما ارسال شد",
          variant: "success"
        })
      );
      loading(false);
    })
    .catch(err => {
      handleError(dispatch, err);
      loading(false);
    });
};

export const verifyLink = ({ token, setInfo, history }) => dispatch => {
  validLink(token)
    .then(({ firstName, lastName }) =>
      setInfo({ firstName, lastName, loading: false })
    )
    .catch(() => {
      dispatch(
        notification({
          message: "لینک معتبر نیست",
          variant: "error"
        })
      );
      history.replace("/sign-in");
    });
};

export const submitNewPassword = ({ token, password, history }) => dispatch => {
  submit({ token, password })
    .then(user => {
      dispatch(setUser(user));
      dispatch(
        notification({
          message: "رمز عبور جدید با موفقیت ثبت گردید",
          variant: "success"
        })
      );
      history.replace("/");
    })
    .catch(() => {
      dispatch(
        notification({
          message: "لینک معتبر نیست",
          variant: "error"
        })
      );
      history.replace("/sign-in");
    });
};
